import { jsx } from "react/jsx-runtime";
const Bookmark = ({ className = 'tw-text-neutral-light-800', size = 32 })=>/*#__PURE__*/ jsx("svg", {
        className: className,
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        children: /*#__PURE__*/ jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9 3a3 3 0 0 0-3 3v14a1 1 0 0 0 1.514.858L12 18.166l4.485 2.692A1 1 0 0 0 18 20V6a3 3 0 0 0-3-3H9Z",
            fill: "none",
            className: "tw-fill-current"
        })
    });
const Bookmark_Bookmark = Bookmark;
export default Bookmark_Bookmark;
